<template>
  <span
    :class="{
      'currency-negative-text-color': dollarValue < 0 && highlightNegative,
      'font-weight-bold': strong
    }"
    >{{ $filters.currency(dollarValue, fallback) }}</span
  >
</template>

<script>
export default {
  props: {
    dollarValue: {
      type: Number,
      required: true
    },
    fallback: {
      type: String,
      required: false,
      default: ''
    },
    strong: {
      type: Boolean,
      required: false,
      default: true
    },
    highlightNegative: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data: () => ({}),

  methods: {},

  mounted() {}
}
</script>

<style scoped>
.currency-negative-text-color {
  color: red !important;
}
</style>
